import React from "react";
import UltraKivamliCamasirSuyu from "../Components/product/UltraKivamliCamasirSuyu";
import PageHeader from "../Components/common/PageHeader";
import { t } from "i18next";
import ProductSEO from "../Components/common/ProductSEO";

function UltraKivamliCamasirSuyuPage() {
    return (
        <>
            <ProductSEO
                name="Ultra Kıvamlı Çamaşır Suyu"
                description="Kalın formülü ile yoğun temizlik ve hijyen sağlar."
                slug="ultrakivamlicamasirsuyu"
                imagePath="assets/images/20-kg/3.webp"
            />
            <PageHeader title={t("ULTRA KIVAMLI ÇAMAŞIR SUYU")} />
            <UltraKivamliCamasirSuyu />
        </>
    );
}

export default UltraKivamliCamasirSuyuPage;